import { TAG_STATUS } from '../../../constants/service/app/tagConstants';
import { _LIST_PAGINATION_MODEL } from '../app/models';

/**
 *  태그 리스트 검색 박스 모델
 */
export const TAG_LIST_SEARCH_DATA_MODEL = {
  /**
   *  태그 상태
   */
  tagStatus: null,
  /**
   *  태그명
   */
  tagName: null,
  /**
   *  태그 그룹 리스트
   */
  tagGroupIdList: [],
  /**
   *  태그 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  태그 리스트 검색 옵션 모델
 */
export const TAG_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  태그 상태
   */
  tagStatus: null,
  /**
   *  태그명
   */
  tagName: null,
  /**
   *  태그 그룹 리스트
   */
  tagGroupIdList: [],
  /**
   *  태그 생성일
   */
  createDate: null,
};

/**
 *  태그 리스트에서 연결된 아이템 리스트 정렬 옵션 모델
 */
export const TAG_LIST_SORT_OPTION_MODEL = {
  /**
   *  태그 이미지 존재 여부
   */
  url: null,
  /**
   *  유저 태그 팔로워 수
   */
  userFollowerCount: null,
  /**
   *  클릭 수 (조회)
   */
  clickCount: null,
  /**
   *  검색 수 (조회)
   */
  searchCount: null,
  /**
   *  연결된 상품 수
   */
  productLinkCount: null,
  /**
   *  연결된 상점 수
   */
  storeLinkCount: null,
  /**
   *  생성일
   */
  createDate: 'descend',
};

/**
 *  태그 그룹 리스트 검색 박스 모델
 */
export const TAG_GROUP_LIST_SEARCH_DATA_MODEL = {
  /**
   *  태그 그룹명
   */
  tagGroupName: null,
  /**
   *  태그 그룹 생성일
   */
  tagGroupCreateDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  태그 그룹 타입
   */
  tagGroupType: null,
};

/**
 *  태그 그룹 리스트 검색 옵션 모델
 */
export const TAG_GROUP_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  태그 그룹명
   */
  tagGroupName: null,
  /**
   *  태그 그룹 생성일
   */
  tagGroupCreateDate: null,
  /**
   *  태그 그룹 타입
   */
  tagGroupType: null,
};

/**
 *  태그 그룹 리스트에서 연결된 아이템 리스트 정렬 옵션 모델
 */
export const TAG_GROUP_LIST_SORT_OPTION_MODEL = {
  /**
   *  태그 그룹 생성일
   */
  tagGroupCreateDate: 'descend',
};

/**
 *  태그 검색 키워드 모델
 */
export const TAG_SEARCH_KEYWORD = {
  type: null,
  text: null,
};

/**
 *  태그에 연결된 아이템 리스트 검색 박스 모델
 */
export const TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_DATA_MODEL = {
  /**
   *  키워드 검색
   */
  searchKeyword: TAG_SEARCH_KEYWORD,
};

/**
 *  태그에 연결된 아이템 리스트 검색 옵션 모델
 */
export const TAG_DETAIL_RELATED_ITEM_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  키워드 검색
   */
  searchKeyword: TAG_SEARCH_KEYWORD,
};

/**
 *  연결할 태그 리스트 필터 옵션 모델
 */
export const TAG_LINK_LIST_FILTER_OPTION_MODEL = {
  /**
   *  태그 id
   */
  tagId: null,
  /**
   *  태그명
   */
  tagName: null,
};

/**
 *  연결할 태그 리스트 정렬 옵션 모델
 */
export const TAG_LINK_LIST_SORT_OPTION_MODEL = {
  /**
   *  태그 이미지 존재 여부
   */
  url: null,
  /**
   *  생성일
   */
  createDate: 'descend',
};

/**
 *  연결할 태그 리스트 모델
 */
export const TAG_LINK_LIST_MODEL = {
  /**
   *  연결될 아이템 리스트
   */
  itemList: {
    /**
     * 리스트
     */
    list: [],
    /**
     *  필터 옵션
     */
    filterOption: TAG_LINK_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션
     */
    sortOption: TAG_LINK_LIST_SORT_OPTION_MODEL,
    /**
     * pagination
     */
    pagination: _LIST_PAGINATION_MODEL,
  },
  /**
   *  연결된 아이템 리스트
   */
  selectedItemList: {
    list: [],
    idList: [],
  },
};

/**
 *  태그 정보 모델
 */
export const TAG_INFO_MODEL = {
  /**
   *  태그 id
   */
  tagId: null,
  /**
   *  태그명
   */
  tagName: null,
  /**
   *  태그명 중복 여부
   */
  isDuplicationTagName: false,
  /**
   *  태그 상태
   */
  status: TAG_STATUS.inactive,
  /**
   *  태그 그룹 id 리스트
   */
  tagGroupIdList: [],
  /**
   *  연관 태그 리스트
   */
  relatedTagList: [],
  /**
   *  태그 이미지
   */
  tagImg: [],
};
